module.exports = __webpack_public_path__ + "static/media/light-theme-geofence-stop.ea7921ed.svg";